import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import StyledComponentPanel from "../../../../components/atoms/ComponentPanel/StyledComponentPanel";
import {
  getSplicePerTranscript,
  getTranscriptOptions,
  getSelectedTranscript,
} from "../../../../state/selectors/spliceAi/selectors";
import SpliceVaultTable from "./SpliceVaultTable";
import HelperText from "../../../../components/atoms/HelperText";
import Title from "./Title";

function SpliceVault() {
  const spliceDataPerTranscript = useSelector(getSplicePerTranscript);
  const transcriptOptions = useSelector(getTranscriptOptions);
  const defaultTranscript = useSelector(getSelectedTranscript);
  const [selectedTr, setSelectedTr] = useState(defaultTranscript);

  const { type, exonNo, transcript, events } = useMemo(() => {
    const defaultRes = { type: "-", exonNo: "-", events: [], transcript: "-" };
    return spliceDataPerTranscript?.[selectedTr?.value] ?? defaultRes;
  }, [selectedTr, spliceDataPerTranscript]);

  return (
    <StyledComponentPanel title={<Title />}>
      <div className="tw-m-4 tw-text-blueGray-600">
        <div className="tw-mt-6 tw-mb-12 tw-flex tw-flex-col tw-items-center tw-justify-items-center">
          <div className="tw-font-bold tw-text-xs tw-my-2 tw-text-blueGray-500">
            Select transcript
          </div>
          <div className="tw-w-64 tw-flex tw-items-center">
            <div className="tw-flex-grow">
              <Select
                value={selectedTr}
                options={transcriptOptions}
                isSearchable={false}
                onChange={setSelectedTr}
              />
            </div>
            <HelperText customText="Results are reported by default for transcript used in the Germline Classification. You can change the transcript to view results for other transcripts available in the SpliceVault database with a TSL = 1 (highest supported evidence)." />
          </div>
        </div>

        <SpliceVaultTable
          transcript={transcript}
          events={events}
          type={type}
          exonNo={exonNo}
        />
      </div>
    </StyledComponentPanel>
  );
}

export default withErrorGuard(SpliceVault, "SpliceVault", "SpliceVault");
